import * as React from "react";
import { createContext, Fragment, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { Button, Dialog, DialogActions, DialogTitle } from "@mui/material";
const semver = require('semver');
const semverDiff = require('semver/functions/diff');
const emptyContext = {
    baseUrl: "",
    setSelectedHelpPage: (page) => console.error(`Empty context should not call setSelectedHelpPage(${page}), you most likely do not have <HelpSettingsContextProvider/> in your component tree.`),
    clearSelectedHelpPage: () => console.error(`Empty context should not call clearSelectedHelpPage(), you most likely do not have <HelpSettingsContextProvider/> in your component tree.`),
    setSelectedHelpAnchor: (anchor) => console.error(`Empty context should not call setSelectedHelpAnchor(${anchor}), you most likely do not have <HelpSettingsContextProvider/> in your component tree.`),
    clearSelectedHelpAnchor: () => console.error(`Empty context should not call clearSelectedHelpAnchor(), you most likely do not have <HelpSettingsContextProvider/> in your component tree.`),
    setSelectedHelpLanguage: (language) => console.error(`Empty context should not call setSelectedHelpLanguage(${language}), you most likely do not have <HelpSettingsContextProvider/> in your component tree.`),
    clearSelectedHelpLanguage: () => console.error(`Empty context should not call clearSelectedHelpLanguage(), you most likely do not have <HelpSettingsContextProvider/> in your component tree.`),
};
const HelpSettingsContext = createContext(emptyContext);
export function HelpSettingsContextProvider({ baseUrl, localStorageVar, changeLogUrl, currentVersion, dialogTitle, dialogContent, children }) {
    const [selectedHelpPage, setSelectedHelpPage] = useState();
    const [selectedHelpAnchor, setSelectedHelpAnchor] = useState();
    const [selectedHelpLanguage, setSelectedHelpLanguage] = useState();
    const handleSetSelectedHelpPage = useCallback((helpPage) => {
        setSelectedHelpPage(helpPage);
    }, []);
    const [openDialog, setOpenDialog] = useState(false);
    const clearSelectedHelpPage = useCallback(() => {
        setSelectedHelpPage(undefined);
    }, []);
    const handleSetSelectedHelpAnchor = useCallback((helpAnchor) => {
        setSelectedHelpAnchor(helpAnchor);
    }, []);
    const clearSelectedHelpAnchor = useCallback(() => {
        setSelectedHelpAnchor(undefined);
    }, []);
    const handleSetSelectedHelpLanguage = useCallback((helpLanguage) => {
        setSelectedHelpLanguage(helpLanguage);
    }, []);
    const clearSelectedHelpLanguage = useCallback(() => {
        setSelectedHelpLanguage(undefined);
    }, []);
    const defaultContext = useMemo(() => ({
        baseUrl,
        selectedHelpPage: selectedHelpPage, setSelectedHelpPage: handleSetSelectedHelpPage, clearSelectedHelpPage: clearSelectedHelpPage,
        selectedHelpAnchor: selectedHelpAnchor, setSelectedHelpAnchor: handleSetSelectedHelpAnchor, clearSelectedHelpAnchor: clearSelectedHelpAnchor,
        selectedHelpLanguage: selectedHelpLanguage, setSelectedHelpLanguage: handleSetSelectedHelpLanguage, clearSelectedHelpLanguage: clearSelectedHelpLanguage,
    }), [baseUrl,
        selectedHelpPage, handleSetSelectedHelpPage, clearSelectedHelpPage,
        selectedHelpAnchor, handleSetSelectedHelpAnchor, clearSelectedHelpAnchor,
        selectedHelpLanguage, handleSetSelectedHelpLanguage, clearSelectedHelpLanguage
    ]);
    useEffect(() => {
        if (changeLogUrl && localStorageVar && currentVersion) {
            const lastSeenVersion = localStorage.getItem(localStorageVar);
            if (lastSeenVersion &&
                semver.lt(lastSeenVersion, currentVersion) &&
                ["major", "minor"].includes(semverDiff(lastSeenVersion, currentVersion))) {
                setOpenDialog(true);
            }
            else {
                localStorage.setItem(localStorageVar, currentVersion);
            }
        }
    }, []);
    function handleOk() {
        if (localStorageVar && currentVersion) {
            localStorage.setItem(localStorageVar, currentVersion);
        }
        setOpenDialog(false);
    }
    return (React.createElement(Fragment, null,
        React.createElement(HelpSettingsContext.Provider, { value: defaultContext }, children),
        React.createElement(Dialog, { open: openDialog, onClose: () => setOpenDialog(false), fullWidth: true },
            React.createElement(DialogTitle, null, dialogTitle),
            dialogContent,
            React.createElement(DialogActions, null,
                React.createElement(Button, { variant: "outlined", onClick: handleOk }, "OK")))));
}
export function useHelpSettingsContext() {
    return useContext(HelpSettingsContext);
}
//# sourceMappingURL=HelpSettingsContext.js.map